var map = {
	"./20211122_175133-min.jpg": 717,
	"./20211124_080149-min.jpg": 168,
	"./20220206_135055-min.jpg": 1054,
	"./20220206_135108-min.jpg": 3993,
	"./20220408_073310-min.jpg": 918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;